import React from "react";
import { Button } from "react-bootstrap";
import warmtransferabort from "../../../Dialer/CallListContainer/assets/images/warmtransferabort.svg";

const { REACT_APP_STATIC_ASSETS_BASE_URL } = process.env;

class AbortTransfer extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { abortTransfer, callElement } = this.props;
    return (
      <Button
        disabled={window.shouldDisableTransferActionBtn}
        className="removecolorbut"
        onClick={() => {
          window.shouldDisableTransferActionBtn = true;
          abortTransfer(callElement);
        }}
      >
        <img
          alt=""
          src={`${REACT_APP_STATIC_ASSETS_BASE_URL}${warmtransferabort}`}
        />
        <h4>Abort Transfer</h4>
      </Button>
    );
  }
}

export default AbortTransfer;
